





























































































import Component from 'vue-class-component'
import Switcher from '@/components/Switcher.vue'
import Icon from '@/components/Icon.vue'
import SharedFunctions from '@/views/app/management/review-statements/SharedFunctions'
import { formatResidentAddress, formatTypesOfContact } from '@/utils/helpers'
import StatusStatement from '@/components/statuses/StatusStatement.vue'

@Component({
  props: {
    statement: {
      type: Object,
      require: true
    }
  },
  components: {
    StatusStatement,
    Switcher,
    Icon
  }
})

export default class StatementResidentContact extends SharedFunctions {
  setDeliverToRoom (value: any) {
    this.$emit('setDeliverToRoom', value)
  }

  get mailContact () {
    return this.$props.statement.recipient.mailContact
  }

  get batchStatements () {
    return this.$store.state.statement.batchStatements
  }

  get residentAddress () {
    if (!this.mailContact) return `Recipient was removed from ${this.resident.origin}`
    return formatResidentAddress(this.mailContact)
  }

  get contactEmail () {
    if (!this.mailContact || !this.mailContact.email) {
      return `Recipient was removed from ${this.resident.origin}`
    }
    return this.mailContact.email
  }

  get typesOfContact () {
    return formatTypesOfContact(this.mailContact)
  }

  async updateAndNavigate (statement: any) {
    await this.fetchList()
    await this.changeStatement(statement.id)
  }
}
